'use strict';

import $ from 'jquery';
require('./setup');

/**
 * PC, SP共通
 */
